<template>
    <CardBase>
        <h2 class="text-lg font-bold text-center mt-5">{{ $t('component.search.title') }}</h2>
        <h2 v-if="error !== ''" class="text-red-600 text-center font-bold mt-5">{{ error }}</h2>
        <div class="mx-4 mt-8 mb-12">
            <div class="relative">
                <datepicker
                        input-class="block appearance-none bg-white border border-blue-600 text-gray-700 py-3 px-4 rounded leading-tight w-full"
                        :placeholder="$t('component.search.input.placeholder')"
                        v-model="date"
                        :language="lang"
                        format="dd.MM.yyyy"
                        :highlighted="highlighted"
                        :disabled-dates="{to: yesterday}"
                        @input="changedDate"
                        @selected="selectedDate"></datepicker>
                <div class="cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <CalendarSVG></CalendarSVG>
                </div>
            </div>
        </div>
    </CardBase>
</template>

<script>
    import {MissionService} from "@/services/mission.service";
    import CardBase from "@/components/shared/CardBase";
    import CalendarSVG from "@/components/shared/svgs/CalendarSVG";
    import Datepicker from 'vuejs-datepicker';
    import {de, pl} from 'vuejs-datepicker/dist/locale'
    import {mapGetters} from "vuex";
    import {EventBus} from "../../event-bus";

    export default {
        name: "SearchCard",
        data() {
            return {
                showPicker: false,
                date: '',
                error: '',
                highlighted: {
                    dates: [
                        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                    ],
                    includeDisabled: true
                }
            }
        },
        computed: {
            yesterday() {
                let today = new Date();
                let yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                return yesterday;
            },
            lang() {
                if (this.$i18n.locale === 'de') {
                    return de;
                } else if (this.$i18n.locale === 'pl') {
                    return pl;
                }

                return de;
            },
            ...mapGetters('auth', {
                'loggedIn': 'loggedIn'
            }),
            ...mapGetters('mission', {
                getAvailabilityDate: 'GET_ANONYMIZED_AVAILABILITY_DATE'
            })
        },
        created() {
            EventBus.$on('onChangeStartDate', this.onChangeStartDateListener);
        },
        mounted() {
            this.date = this.getAvailabilityDate;
            this.$emit('date', this.date);
        },
        beforeDestroy() {
            EventBus.$off('onChangeStartDate', this.onChangeStartDateListener)
        },
        components: {CalendarSVG, CardBase, Datepicker},
        methods: {
            onChangeStartDateListener(startDate) {
                this.date = startDate;
                this.$store.commit('mission/SET_ANONYMIZED_AVAILABILITY_DATE', startDate);
            },

            changedDate() {
                if (this.loggedIn) {
                    MissionService.setAvailability(this.date.toISOString().slice(0, 10))
                } else {
                    this.$store.commit('mission/SET_ANONYMIZED_AVAILABILITY_DATE', this.date.toISOString().slice(0, 10));
                    this.$emit('date', this.date.toISOString().slice(0, 10));
                }
            },

            selectedDate(date) {
                try {
                    const today = new Date().toISOString().slice(0, 10);
                    if (date.toISOString().slice(0, 10) < today) {
                        this.error = this.$t('component.searchCard.beforeError');
                        this.$emit('input', false);
                    } else {
                        this.error = '';
                        this.$emit('input', true);
                    }
                } catch {
                    this.$emit('input', true);
                }
            }
        }
    }
</script>

<style scoped>

</style>